import { render, staticRenderFns } from "./AppRating.vue?vue&type=template&id=04946ac4&scoped=true&"
import script from "./AppRating.vue?vue&type=script&lang=js&"
export * from "./AppRating.vue?vue&type=script&lang=js&"
import style0 from "./AppRating.vue?vue&type=style&index=0&id=04946ac4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04946ac4",
  null
  
)

export default component.exports